import { type ReactNode } from 'react';
import { Dialog, DialogContent, DialogDescription, DialogTitle, DialogTrigger } from '~/components/ui/dialog';

interface YouTubeDialogProps {
  embedUrl: string;
  children: ReactNode;
}

function YouTubeDialog({ embedUrl, children }: YouTubeDialogProps) {
  const enhancedEmbedUrl = new URL('?autoplay=1', embedUrl).href;

  return (
    <Dialog>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="max-w-5xl border-0 p-0">
        <DialogTitle className="hidden">Youtube Dialog</DialogTitle>
        <DialogDescription className="hidden">Youtube Dialog</DialogDescription>
        <iframe
          className="aspect-video h-full w-full border-0"
          width="560"
          height="315"
          src={enhancedEmbedUrl}
          title="YouTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        />
      </DialogContent>
    </Dialog>
  );
}

export { YouTubeDialog, type YouTubeDialogProps };
